function isObject(maybeObj: any) {
  return Object.prototype.toString.call(maybeObj) === "[object Object]"
}

export const parsePossibleJSON = (maybeJSON: unknown) => {
  if (Array.isArray(maybeJSON) || isObject(maybeJSON)) {
    return maybeJSON
  }

  if (typeof maybeJSON === "string") {
    try {
      return JSON.parse(maybeJSON)
    } catch (e) {
      console.warn(e)

      try {
        return JSON.parse(convertHtmlQuotes(maybeJSON))
      } catch (e) {
        console.warn(e)
      }
    }
  }

  // undefined is not a type in JSON,
  // so we use it here to signal invalid input
  return undefined
}

/**
 * Format string, via simplistic sprintf equivalent
 * @example String.format('{0} is super, but {1} is best! {{0}}', 'Duet', 'Coffee'); -> "Duet is super, but Coffee ist best! {0}"
 *
 */
// @ts-ignore
if (!String.format) {
  // @ts-ignore
  String.format = function (format) {
    var args = Array.prototype.slice.call(arguments, 1)
    return format.replace(/\{\{|\}\}|\{(\d+)\}/g, function (curlyBrack, index) {
      return curlyBrack == "{{" ? "{" : curlyBrack == "}}" ? "}" : args[index]
    })
  }
}

const MATCH_DISALLOWED_CHARS = /[^a-z0-9áéíóúñüöäå \.,_-]/gim
export function sanitizeString(string: string) {
  return string.replace(MATCH_DISALLOWED_CHARS, "").trim()
}

export const convertHtmlQuotes = string => {
  if (typeof string === "string") {
    return string.replace(/&quot;/g, '"').replace(/&apos;/g, '"')
  }
  return string
}

/**
 * Converts the first letter of the string to upper case. Note that with non-latin scrips this may not produce expected results
 */
export const upperCaseFirst = (string: string) => {
  return string && `${string[0].toUpperCase()}${string.slice(1)}`
}

/**
 * Escapes characters that have special meaning in regular expressions
 */
export const regexEscape = (string: string) => {
  return string.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")
}
